import React, { createContext, useContext, useState, useCallback } from 'react';

const ChatPopupContext = createContext();

export const useChatPopup = () => {
  const context = useContext(ChatPopupContext);
  if (!context) {
    throw new Error('useChatPopup must be used within ChatPopupProvider');
  }
  return context;
};

export const ChatPopupProvider = ({ children }) => {
  const [popups, setPopups] = useState({}); // { userId: { userId, userName, userProfilePhoto, room, isMinimized, initialMessage } }

  const openChatPopup = useCallback((userId, userName, userProfilePhoto, initialRoom = null, initialMessage = '') => {
    setPopups(prev => ({
      ...prev,
      [userId]: {
        userId,
        userName,
        userProfilePhoto,
        initialRoom,
        initialMessage,
        isMinimized: false,
      }
    }));
  }, []);

  const closeChatPopup = useCallback((userId) => {
    setPopups(prev => {
      const newPopups = { ...prev };
      delete newPopups[userId];
      return newPopups;
    });
  }, []);

  const toggleMinimizePopup = useCallback((userId) => {
    setPopups(prev => ({
      ...prev,
      [userId]: {
        ...prev[userId],
        isMinimized: !prev[userId]?.isMinimized,
      }
    }));
  }, []);

  const updatePopupRoom = useCallback((userId, room) => {
    setPopups(prev => ({
      ...prev,
      [userId]: {
        ...prev[userId],
        initialRoom: room,
      }
    }));
  }, []);

  return (
    <ChatPopupContext.Provider
      value={{
        popups,
        openChatPopup,
        closeChatPopup,
        toggleMinimizePopup,
        updatePopupRoom,
      }}
    >
      {children}
    </ChatPopupContext.Provider>
  );
};

